import API from '../dataApi';

// -- Financial Year ------------------------------------------------------------
export const getCurrentFY = () => API.get('/financial-year/current');
export const getFYList = () => API.get('/financial-year/list');
